import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { PackageCheck } from "lucide-react";

// Record received quantities per line; backend feeds job costing.
export const ReceiveDialog = ({ po, open, onOpenChange, onDone }) => {
  const [qty, setQty] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (po) setQty(Object.fromEntries(po.items.map(i => [i.line_id, i.quantity_received || 0]))); }, [po]);
  if (!po) return null;

  const receiveAll = () => setQty(Object.fromEntries(po.items.map(i => [i.line_id, i.quantity])));
  const submit = async () => {
    setSaving(true);
    try {
      const r = await axios.post(`${API}/procurement/lists/${po.po_id}/receive`, { items: po.items.map(i => ({ line_id: i.line_id, quantity_received: Number(qty[i.line_id]) || 0 })) });
      toast.success(r.data.status === "received" ? `${po.po_number} fully received` : "Receipt recorded", { description: r.data.cost_entries_added ? `${r.data.cost_entries_added} material cost line(s) added to job costing` : undefined });
      onDone?.(r.data);
      onOpenChange(false);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[85vh] overflow-y-auto" aria-describedby={undefined} data-testid="receive-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><PackageCheck className="w-5 h-5 text-green-600" /> Receive {po.po_number}</DialogTitle></DialogHeader>
        <div className="space-y-2">
          {po.items.map((i, idx) => (
            <div key={i.line_id} className="flex items-center gap-3 p-2 border rounded-lg">
              <div className="flex-1 min-w-0"><p className="text-sm font-medium truncate">{i.name}{i.size ? ` — ${i.size}` : ""}</p><p className="text-xs text-slate-500">Ordered {i.quantity} {i.unit}</p></div>
              <Input type="number" min="0" max={i.quantity} step="any" className="w-24 h-9" value={qty[i.line_id] ?? 0} onChange={e => setQty({ ...qty, [i.line_id]: e.target.value })} data-testid={`receive-qty-${idx}`} />
            </div>
          ))}
        </div>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={receiveAll} data-testid="receive-all-btn">Everything arrived</Button>
          <Button onClick={submit} disabled={saving} data-testid="receive-submit-btn">Save receipt</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
